import { useMemo } from 'react';

import { usePlanFeature } from '~/hooks/usePlanFeature';
import { useSubscriptionContext } from '~/providers/SubscriptionProvider';

type ShareFeatureFlags = {
  commentsEnabled: boolean;
  canManageCommentsEnabled: boolean;
  customFieldsEnabled: boolean;
  requireAccountEnabled: boolean;
  passcodeEnabled: boolean;
  expirationDateEnabled: boolean;
};

export const useShareSettings = (): ShareFeatureFlags => {
  const { data: subscription } = useSubscriptionContext();
  const canUsePasscodeProtectedLinks = usePlanFeature('passcodeProtectedLinks');

  return useMemo<ShareFeatureFlags>(() => {
    const isPaid = !!subscription?.isOnPaidPlan;

    return {
      commentsEnabled: isPaid,
      canManageCommentsEnabled: isPaid,
      customFieldsEnabled: isPaid,
      requireAccountEnabled: isPaid,
      passcodeEnabled: canUsePasscodeProtectedLinks,
      expirationDateEnabled: isPaid,
    };
  }, [subscription, canUsePasscodeProtectedLinks]);
};
